export const LOAD_WARRANTIES_DATA_SUCCESS = 'LOAD_WARRANTIES_DATA_SUCCESS';
export const LOAD_WARRANTIES_DATA_STARTED = 'LOAD_WARRANTIES_DATA_STARTED';
export const LOAD_WARRANTIES_SUMMARY_STARTED = 'LOAD_WARRANTIES_SUMMARY_STARTED';
export const LOAD_WARRANTIES_SUMMARY_SUCCESS = 'LOAD_WARRANTIES_SUMMARY_SUCCESS';
export const LOAD_WARRANTIES_DATA_FAILED = 'LOAD_WARRANTIES_DATA_FAILED';
export const WARRANTY_DELETED = 'WARRANTY_DELETED';
export const ALL_WARRANTIES_DELETED = 'ALL_WARRANTIES_DELETED';
